import React from "react";

const Footer = () => {
  return (
    <>
      <div className="row footer justify-content-center">
        <div className="col-md-5">
          <div className="text-center">
            <h2 className="footer-title">Eat, Cook, Repeat</h2>
            <p>Share your best recipe by uploading here !</p>
          </div>
        </div>
      </div>
    </>
  );
};

export default Footer;
